var $0159854399308e2e$exports = {};
$0159854399308e2e$exports = {
  "Clear search": "Borrar b\xFAsqueda"
};
export { $0159854399308e2e$exports as default };